import React from 'react';
import {
  Box, CardActions, TextField, Typography, IconButton, Tooltip,
} from '@material-ui/core';
import { Delete, AttachFile } from '@material-ui/icons';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import {
  styles, Button, Form, theme,
} from './styles';

const EditDialog = (props) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const {
    openDialog, handleAcept, onCloseDialog, onChangeInputs, formEdit, files, handleDeleteFile,
  } = props;
  return (
    <Form maxWidth="sm" open={openDialog} onClose={onCloseDialog}>
      <Box
        component="form"
        onSubmit={(event) => {
          handleAcept(event);
          onCloseDialog();
        }}
      >
        <CardBody>
          <ThemeProvider theme={theme}>
            <TextField
              className={classes.textfield}
              value={formEdit.titulo}
              onChange={(event) => onChangeInputs(event.target.value, 'titulo')}
              required
              fullWidth
              label="Titulo"
              variant="outlined"
            />
            <TextField
              className={classes.textfield}
              value={formEdit.resumen}
              onChange={(event) => onChangeInputs(event.target.value, 'resumen')}
              required
              fullWidth
              label="Resumen"
              variant="outlined"
              multiline
              minRows={6}
            />
            <TextField
              className={classes.textfield}
              value={formEdit.detalle}
              onChange={(event) => onChangeInputs(event.target.value, 'detalle')}
              required
              fullWidth
              label="Detalle"
              variant="outlined"
              multiline
              minRows={6}
            />
            <TextField
              className={classes.textfield}
              value={formEdit.indicadores}
              onChange={(event) => onChangeInputs(event.target.value, 'indicadores')}
              required
              fullWidth
              label="Indicadores"
              variant="outlined"
              multiline
              minRows={6}
            />
          </ThemeProvider>
          <Box>
            {files?.map((file, index) => (
              <Box key={file.id} className={classes.filesContainer}>
                <Typography className={classes.fileName}>
                  {file.nombre_adjunto}
                </Typography>
                &nbsp;
                <IconButton
                  className={classes.icon}
                  onClick={() => handleDeleteFile(index)}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        </CardBody>
        <CardActions className={classes.cardAction}>
          <Tooltip title="Adjuntar archivo">
            <IconButton component="label" variant="contained">
              <AttachFile />
              <input
                type="file"
                hidden
                onChange={(e) => {
                  onChangeInputs(e.target.files, 'files');
                }}
              />
            </IconButton>
          </Tooltip>
          <Button type="button" onClick={onCloseDialog}>
            Cancelar
          </Button>
          <Button type="submit">Aceptar</Button>
        </CardActions>
      </Box>
    </Form>
  );
};

export default EditDialog;
